import React from 'react'
import Slider from 'react-slick'
import useWindowSize from '../../hooks/useWindowSize'

// const recognitionDesktop = [
//     "https://assets.learntube.ai/files/Onboarding_Revamp/Group%208182.png?updatedAt=1694583914135",
//     "https://assets.learntube.ai/files/Onboarding_Revamp/Group%206958.png?updatedAt=1694584148121",
//     "https://assets.learntube.ai/files/Onboarding_Revamp/Group%206957.svg?updatedAt=1694584149737",
//     "https://assets.learntube.ai/files/Onboarding_Revamp/Group%206956.svg?updatedAt=1694584149415",
// ]
const recognitionDesktop = [
    "https://assets.learntube.ai/files/Onboarding_Revamp/Group%208182%20(1).png?updatedAt=1694776801051",
    "https://assets.learntube.ai/files/Onboarding_Revamp/Group%206958.png?updatedAt=1694584148121",
    "https://assets.learntube.ai/files/Onboarding_Revamp/Group%206957.svg?updatedAt=1694584149737",
    "https://assets.learntube.ai/files/Onboarding_Revamp/Group%206956.svg?updatedAt=1694584149415",
]



const RecognitionSection = () => {

    const { width } = useWindowSize()

    const workAtsettings = {
        dots: false,
        slidesToShow: 3,
        rows: 1,
        speed: 1000,
        autoplay: true,
        autoplaySpeed: 3000,
        easing: 'linear',
        cssEase: "linear",
        infinite: true,
        arrows: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                }
            },
    
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3.5,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: width <= 360 ? 3.1 : 3.3,
                    infinite: true,
                    dots: false,
                    arrows: false,
                    swipeToSlide: false,
                }
            },
        ]
    };
    return (
        <div className='w-full'>
            <div className='md:hidden'>
                <div className='w-full'>
                    <img src={recognitionDesktop[0]} alt="review image" className='w-full h-auto'/>
                </div>
                <div className='flex justify-center mt-3'>
                    <div className='max-w-[100px] h-[125px] mr-2'>
                        <img src={recognitionDesktop[1]} alt="review image" className='w-full h-full object-fill'/>
                    </div>
                    <div className='max-w-[100px] h-[120px] mr-2'>
                        <img src={recognitionDesktop[2]} alt="review image" className='w-full h-full object-cover rounded-xl'/>
                    </div>
                    <div className='max-w-[100px] h-[120px] ml-0.5'>
                        <img src={recognitionDesktop[3]} alt="review image" className='w-full h-full object-cover rounded-xl'/>
                    </div>
                </div>
            </div>
            <div className='hidden md:flex'>
                <div className='w-1/2 h-[145px] flex items-center bg-[#2D4F71] rounded-xl'>
                    <img src={recognitionDesktop[0]} alt="review image" />
                </div>
                <div className='flex w-1/2 justify-between ml-1'>
                    <div className='w-1/3 h-[150px] ml-1'>
                        <img src={recognitionDesktop[1]} alt="review image" className='w-full h-full object-fill'/>
                    </div>
                    <div className='w-[30%] h-[145px] -ml-1'>
                        <img src={recognitionDesktop[2]} alt="review image" className='w-full h-full object-cover rounded-xl'/>
                    </div>
                    <div className='w-[30%] h-[145px]'>
                        <img src={recognitionDesktop[3]} alt="review image" className='w-full h-full object-cover rounded-xl'/>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default RecognitionSection